<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Pergunta</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span> Unidade:
                      </label>
                      <v-select :options="unidades" :label="'titulo'" :reduce="(unidades) => unidades.id"
                        v-model="pergunta.unidade_id"></v-select>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span> Título:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="pergunta.titulo"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-12">
                      <label for="Email">
                        <span class="required"></span> Descrição:
                      </label>
                      <textarea class="form-control" rows="10" cols="10" v-model="pergunta.descricao"></textarea>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Ordem:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="pergunta.ordem"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Tipo Pergunta:
                      </label>
                      <select v-model="pergunta.tipo_pergunta" class="form-control">
                        <option value="A">Alternativa</option>
                        <option value="T">Texto</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Numerador:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="pergunta.numerador"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Ocultar:
                      </label>
                      <select v-model="pergunta.ocultar" class="form-control">
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Obrigatório:
                      </label>
                      <select v-model="pergunta.obrigatorio" class="form-control">
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Identificador:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="pergunta.identificador"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="password">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="pergunta.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/perguntas" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      pergunta: {
        status: '1',
        ocultar: '0'
      },
      unidades: [],
      
      

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {

    save: function () {
      const self = this;
      let api = self.$store.state.api + "perguntas";

      if (self.pergunta.id) {
        self.pergunta._method = "PUT"
        api += "/" + self.pergunta.id;
      }

      axios
        .post(api, self.pergunta)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/perguntas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.pergunta.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.pergunta.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.pergunta.logradouro = self.endereco.logradouro;
            self.pergunta.bairro = self.endereco.bairro;
            self.pergunta.uf = self.endereco.uf;
            self.pergunta.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getPergunta: function (id) {
      const self = this;
      const api = self.$store.state.api + "perguntas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.pergunta = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  
  },
  mounted: function () {
    const self = this;

    self.getUnidades();
   
    let id = self.$route.params.id;
    if (id) {
      self.getPergunta(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>